// src/features/game/components/bottomsheets/StarPointConsumeSheet.tsx
import React from 'react';
import { AlertCircle, Star } from 'lucide-react';
import ImgHeaderStar from '@/assets/app/images/common/header/header-star.png';
import ImgWarning from '@/assets/app/images/adventure/icon_warning.png';
import AppButton from '@/shared/components/ui/new/AppButton';

interface StarPointConsumeSheetProps {
  points: number;
  reward: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const StarPointConsumeContent: React.FC<StarPointConsumeSheetProps> = ({
  points,
  reward,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="p-6 space-y-6" style={{ borderRadius: '0 0 25px 25px' }}>
      {/* 타이틀 */}
      <h2
        className="text-xl font-bold text-[800] text-center m-0 mb-3 f-one-pop"
        style={{ fontSize: 26 }}
      >
        별 포인트 <span className="text-[red]">{points}</span>개가 소모돼요
      </h2>

      {/* 보유 별 */}
      <div className="flex flex-col items-center justify-center gap-2">
        <span className="">보유 별포인트 :</span>

        <div className="status-item">
          <img src={ImgHeaderStar} alt="star" className="status-icon" />
          <div className="status-text star">
            <span className="status-value f-one-pop" style={{ fontSize: 18 }}>
              {reward}
            </span>
          </div>
        </div>
      </div>

      {/* 안내 문구 */}
      <p className="text-center text-[24px] font-bold text-[#0094EF]">
        별 포인트 포인트를 사용하여
        <br />
        모험을 떠나볼까요?
      </p>

      {/* 경고 메시지 */}
      <div className="flex gap-3 justify-center ">
        <img src={ImgWarning} style={{ width: 60, height: 62 }} />
        <div className="text-[16px] text-red-600" style={{ lineHeight: 1.3 }}>
          <strong>알아두세요!</strong>
          <br />
          문제풀이를 중단하더라도 소모된
          <br /> 별 포인트는 환원되지 않아요.
        </div>
      </div>

      {/* 버튼 그룹 */}
      <div className="space-y-3">
        <AppButton className="f-one-pop text-[20px]" onConfirm={onConfirm} message="계속하기" />
        <AppButton
          className="f-one-pop text-[20px]"
          backgroundColor="#D4D4D4"
          boxShadowColor="#B7B7B7"
          style={{
            marginTop: 10,
          }}
          onConfirm={onCancel}
          message="다음에 할래요"
        />
      </div>
    </div>
  );
};
